import "./Loader.css"

const Loader = () => {
  return (
    <div className="loader-container">
      <h1>Loading...</h1>
    </div>
  )
}

export default Loader